import { initComponent } from './core/init-component.js'
import { addToCart, reRenderShopifySections } from '../components/src/lib/utils'
import { openCart } from './utils/cart.js'

initComponent('.js-quick-view', wrapper => {
  if (wrapper.parentElement !== document.body) {
  document.body.appendChild(wrapper)
  }
  
  const drawer = wrapper.querySelector('.js-quick-view-drawer')
  const overlay = wrapper.querySelector('.js-quick-view-overlay')

  const openDesktop = 'lg:translate-x-0'
  const closedDesktop = 'lg:translate-x-full'
  const openMobile = 'translate-y-0'
  const closedMobile = 'translate-y-[200%]'

  const drawerProductId = drawer.dataset.productId
  const closeButton = drawer.querySelector('.js-quick-view-close')
  const variantButtons = drawer.querySelectorAll('.js-quick-view-variant')
  const mainImage = drawer.querySelector('.js-quick-view-main-image')
  const priceEl = drawer.querySelector('.js-quick-view-price')
  const atcPriceEl = drawer.querySelector('.js-button-atc-secondary')
  const atcButton = drawer.querySelector('.js-quick-view-atc')
  const oosButton = drawer.querySelector('.js-quick-view-oos')
  const engravingButton = drawer.querySelector('.js-quick-view-engraving')
  const detailLinks = drawer.querySelectorAll('.js-quick-view-details')

  let selectedVariantButton = drawer.querySelector('.js-quick-view-variant.bg-brand-black')
  let selectedVariantId = selectedVariantButton?.dataset.variantId

  if (engravingButton && selectedVariantButton) {
    const hasPersonalization = selectedVariantButton.dataset.hasPersonalization === 'true'
    if (!hasPersonalization) engravingButton.classList.add('hidden')
  }

  drawer.classList.add('transition-transform', 'duration-300', 'ease-in-out', closedMobile, closedDesktop)

  overlay.addEventListener('click', closeDrawer)
  closeButton?.addEventListener('click', closeDrawer)

  function openDrawer() {
    drawer.classList.remove(closedDesktop, closedMobile)
    drawer.classList.add(openDesktop, openMobile)
    overlay.classList.remove('opacity-0', 'pointer-events-none')
    overlay.classList.add('opacity-100', 'pointer-events-auto')
    wrapper.removeAttribute('aria-hidden')
    wrapper.removeAttribute('inert')
    wrapper.setAttribute('role', 'dialog')
    wrapper.setAttribute('aria-modal', 'true')
    document.body.style.overflow = 'hidden'
  }

  function closeDrawer() {
    drawer.classList.remove(openDesktop, openMobile)
    drawer.classList.add(closedDesktop, closedMobile)
    overlay.classList.remove('opacity-100', 'pointer-events-auto')
    overlay.classList.add('opacity-0', 'pointer-events-none')
    wrapper.setAttribute('aria-hidden', 'true')
    wrapper.setAttribute('inert', '')
    wrapper.removeAttribute('aria-modal')
    wrapper.removeAttribute('role')
    document.body.style.overflow = ''
  }

  function getBackgroundColorFromImage(img, callback) {
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d', { willReadFrequently: true })
    if (!ctx) return

    const tempImg = new Image()
    tempImg.crossOrigin = 'anonymous'
    tempImg.src = img.src

    tempImg.onload = () => {
      canvas.width = tempImg.width
      canvas.height = tempImg.height
      ctx.drawImage(tempImg, 0, 0)
      const pixel = ctx.getImageData(5, 5, 1, 1).data
      const color = `rgb(${pixel[0]}, ${pixel[1]}, ${pixel[2]})`
      callback(color)
    }
  }

  const quickViewImageWrapper = drawer.querySelector('.js-quick-view-image')
  if (mainImage && quickViewImageWrapper) {
    if (mainImage.complete) {
      getBackgroundColorFromImage(mainImage, color => {
        quickViewImageWrapper.style.backgroundColor = color
      })
    } else {
      mainImage.addEventListener('load', () => {
        getBackgroundColorFromImage(mainImage, color => {
          quickViewImageWrapper.style.backgroundColor = color
        })
      })
    }
  }

  document.addEventListener('openQuickView', e => {
    const eventProductId = e.detail?.productId
    if (!eventProductId || eventProductId !== drawerProductId) return

    const firstDrawerEl = document.querySelector(`.js-quick-view-drawer[data-product-id="${eventProductId}"]`)
    if (drawer !== firstDrawerEl) return

    openDrawer()
    e.stopImmediatePropagation()
  })

  variantButtons.forEach(button => {
    button.addEventListener('click', e => {
      e.preventDefault()

      variantButtons.forEach(b => b.classList.remove('bg-brand-black', 'text-grey-0', '!border-brand-black'))
      button.classList.add('bg-brand-black', 'text-grey-0', '!border-brand-black')

      const img = button.dataset.variantImage
      const price = button.dataset.variantPrice
      const variantId = button.dataset.variantId
      const hasPersonalization = button.dataset.hasPersonalization === 'true'
      const isOOS = button.dataset.oos === 'true'

      selectedVariantId = variantId

      if (img && mainImage) {
        mainImage.src = img
        mainImage.addEventListener('load', () => {
          getBackgroundColorFromImage(mainImage, color => {
            quickViewImageWrapper.style.backgroundColor = color
          })
        }, { once: true })
      }

      if (price) {
        if (priceEl) {
          priceEl.textContent = price
        }

        if (atcPriceEl) {
          atcPriceEl.textContent = price
        }
      }

      if (engravingButton && variantId) {
        const baseUrl = engravingButton.href.split('?')[0]
        engravingButton.href = `${baseUrl}?variant=${variantId}&open=engraving`

        if (hasPersonalization && !isOOS) {
          engravingButton.classList.remove('hidden')
        } else {
          engravingButton.classList.add('hidden')
        }
      }

      if (isOOS) {
        atcButton?.classList.add('hidden')
        oosButton?.classList.remove('hidden')
      } else {
        atcButton?.classList.remove('hidden')
        oosButton?.classList.add('hidden')
      }

      detailLinks.forEach(link => {
        const baseUrl = link.href.split('?')[0]
        link.href = `${baseUrl}?variant=${variantId}`
      })
    })
  })

  atcButton?.addEventListener('click', async e => {
    e.preventDefault()
    const variantId = selectedVariantId || atcButton.getAttribute('data-product-id')
    if (!variantId) return

    atcButton.style.pointerEvents = 'none'
    atcButton.style.opacity = '0.7'

    let properties = {}
    const lineProperties = atcButton.getAttribute('data-line-properties')
    if (lineProperties) {
      try {
        properties = JSON.parse(lineProperties)
      } catch (err) {
        console.warn('Failed to parse line properties JSON', err)
      }
    }

    const payload = {
      items: [
        {
          id: parseInt(variantId, 10),
          quantity: 1,
          properties
        }
      ]
    }

    try {
      await reRenderShopifySections(await addToCart(payload))
      openCart()
      closeDrawer()
    } catch (error) {
      console.error('Add to cart failed:', error)
    } finally {
      atcButton.style.pointerEvents = ''
      atcButton.style.opacity = ''
    }
  })

  oosButton?.addEventListener('click', e => {
    e.preventDefault()

    const modal = wrapper.querySelector('.js-bis-modal')
    if (!modal) return

    const variantNode = drawer.querySelector('.js-quick-view-variant.bg-brand-black')
    if (!variantNode) return

    const variantId = variantNode.dataset.variantId
    const variantTitle = variantNode.textContent.trim()

    const productTitleEl = drawer.querySelector('.js-quickview-product-title')
    const productTitle = productTitleEl ? productTitleEl.textContent.trim() : ''

    modal.openModal({
      productId: drawerProductId,
      variantId,
      productTitle,
      variantTitle
    })
  })

  return {
    unload() {
      document.removeEventListener('openQuickView')
    }
  }
})
